export default "__VITE_ASSET__Dz$hiHSZ__"